import { Link } from "react-router-dom";
import { Organization } from "../../hooks/api";
import useUser from "../../hooks/user";
import { useCurrentPlan } from "../context/organization/organization";
import { useMemo } from "react";

const useIsUpgradeNowVisible = (
  organization: Organization,
  userAuth: unknown,
  currentPlan: string | undefined
) => {
  return useMemo(() => {
    if (organization.translation_seconds_remaining <= 0) return true;
    if (!userAuth) return false;
    if (currentPlan === "starter" && organization.translation_seconds_remaining <= 20 * 60) return true;
    if (currentPlan !== "starter" && organization.translation_seconds_remaining <= 10 * 60) return true;
    return false;
  }, [userAuth, currentPlan, organization.translation_seconds_remaining]);
};

const UpgradeNow = (props: {
  organization: Organization;
  goToCalendly?: boolean;
  className?: string;
}) => {
  const [user] = useUser();
  const currentPlan = useCurrentPlan(props.organization);
  const isVisible = useIsUpgradeNowVisible(props.organization, user.auth, currentPlan);

  const message = useMemo(() => {
    if (currentPlan === "starter") {
      return (
        <h3 className={props.className}>
          <span
            style={{
              color:
                props.organization.translation_seconds_remaining > 0
                  ? "var(--langfinity-green)"
                  : "var(--langfinity-red)",
            }}
          >
            {Math.round(props.organization.translation_seconds_remaining / 60)}
          </span>{" "}
          of 20 min remaining{" "}
          <Link
            style={{ color: "white", textDecoration: "underline" }}
            target="_blank"
            to={
              !props.goToCalendly
                ? "/billing"
                : "https://calendly.com/d/cs8h-bpy-tzc/langfinity-intro"
            }
          >
            Upgrade now
          </Link>
        </h3>
      );
    } else {
      return (
        <h3 className={props.className}>
          <span
            style={{
              color:
                props.organization.translation_seconds_remaining > 0
                  ? "var(--langfinity-green)"
                  : "var(--langfinity-red)",
            }}
          >
            {Math.round(props.organization.translation_seconds_remaining / 60)}
          </span>{" "}
          min remaining{" "}
          <Link
            style={{ color: "white", textDecoration: "underline" }}
            target="_blank"
            to={
              !props.goToCalendly
                ? "/billing"
                : "https://calendly.com/d/cs8h-bpy-tzc/langfinity-intro"
            }
          >
            Get more
          </Link>
        </h3>
      );
    }
  }, [
    currentPlan,
    props.goToCalendly,
    props.className,
    props.organization.translation_seconds_remaining,
  ]);

  if (!isVisible) return;
  return message;
};

UpgradeNow.useIsUpgradeNowVisible = useIsUpgradeNowVisible;

export default UpgradeNow;
